import React, { useState, useEffect } from 'react'

const Poll = ({ poll, timeout }) => {

	const [show, setShow] = useState(false)
	const [pollData, setPollData] = useState(false)
	const [testId, setTestId] = useState(false)
	const [testShown, setTestShown] = useState(false)

	useEffect(() => {
		if (poll !== false) {
			if (testShown !== poll.testID) {
				console.log("poll", poll, timeout, testShown)
				setPollData(poll)
				setTestId(poll.testID)
			}
		} else
			handleClose()
	}, [poll, timeout, testShown])

	useEffect(() => {
		if (testShown !== testId) {
			const t = setTimeout(() => {
				console.log("testId", testId)
				if (testId !== false) {
					setShow(true)
					setTestShown(testId)
				}
			}, timeout)

			return () => clearTimeout(t)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [testId, timeout])

	useEffect(() => {
		if (!show) {
			const t = setTimeout(() => {
				setPollData(false)
			}, 2000)

			return () => clearTimeout(t)
		}
	}, [show])

	const handleClose = () => {
		setShow(false)
	}

	const handleAnswer = e => {
		fetch("https://api.megabitus.com/v1/poll", {
			method: "POST",
			body: JSON.stringify({
				testId: poll.testID,
				pollId: poll.id,
				answer: e.target.value
			})
		})

		handleClose()
	}

	const answers = data => {
		switch (data.type) {
			case 'rating':
				return (
					<>
					{data.values && data.values.length > 0 && (
					<div className="poll__answers__btns">
						{data.values.map((value, index) => (
							<button key={index} className="btn btn-megabitus poll__answers__btns__item" value={value.value} onClick={handleAnswer}>{value.label}</button>
						))}
					</div>
					)}
					{data.labels && data.labels.length > 0 && (
						<div className="poll__answers__desc">
							{data.labels.map((label, index) => (
								<div key={index} className="poll__answers__desc__item">{label}</div>
							))}
						</div>
					)}
					</>
				)
			default:
				return ""
		}
	}

	return pollData && (
		<div className={`poll${show ? ' poll--show' : ''}`}>
			<div className="poll__close" onClick={handleClose}></div>
			<div className="poll__question">
				{poll.question}
			</div>
			<div className="poll__answers">
				{answers(poll.answers)}
			</div>
		</div>
	)
}

export default Poll
